// Modelo PatientAudio para administrador.
export default class PatientAudio {
    fecha={}
    diagnosticos=[]
    od1=""
    od2=""
    od3=""
    od4=""
    od5=""
    od6=""
    od7=""
    od8=""
    oi1=""
    oi2=""
    oi3=""
    oi4=""
    oi5=""
    oi6=""
    oi7=""
    oi8=""
    basal=false

}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/PatientAudio.js